import React from "react"
import cx from "classnames"

const LayoutCardItem = ({ children }: { children: React.ReactNode }) => {
  return <div className="cobalt-layout-card__item">{children}</div>
}

const LayoutCard = ({
  children,
  isPageHeader,
  className,
}: {
  children: React.ReactNode
  isPageHeader?: boolean
  className?: string
}) => {
  return (
    <div
      className={cx("cobalt-layout-card", className, {
        "cobalt-layout--isPageHeader": isPageHeader,
      })}
    >
      {children}
    </div>
  )
}

LayoutCard.Item = LayoutCardItem

export default LayoutCard
